import { render, staticRenderFns } from "./gs-tree-node.vue?vue&type=template&id=23a41817&scoped=true&"
import script from "./gs-tree-node.vue?vue&type=script&lang=ts&"
export * from "./gs-tree-node.vue?vue&type=script&lang=ts&"
import style0 from "./gs-tree-node.vue?vue&type=style&index=0&id=23a41817&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a41817",
  null
  
)

export default component.exports